import { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ASSIGNEE_TYPE } from "../../utils/constants";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import moment from "moment";
import { MoreHorizCircle } from "iconoir-react";
import SelecteUserDialog from "../../components/common/SelecteUserDialog";

const SearchAdvanceDrawer = (props) => {
    const { open, onClose, onOpen, filter, setFilter, taskLevelList, tagList, firstDay, lastDay } =
        props;
    const [advanceFilter, setAdvanceFilter] = useState({
        date_by: null,
        month: new Date(),
        tien_do: null,
        id_task_level: null,
        tag: [],
    });
    useEffect(() => { }, []);
    const [selectUser, setSelectUser] = useState({ isOpen: false, type: "" });
    useEffect(() => {
        if (!open) return;
        setAdvanceFilter({
            ...filter,
            month: filter.from_date,
            tag: filter?.tag?.split(","),
        });
    }, [open]);

    const handleChangeDateBy = (event) => {
        setAdvanceFilter({
            ...advanceFilter,
            date_by: event.target.value,
        });
    };

    const handleChangeMonth = (value) => {
        setAdvanceFilter({
            ...advanceFilter,
            month: value,
        });
    };
    const handleChangeTienDo = (event) => {
        setAdvanceFilter({
            ...advanceFilter,
            tien_do: event.target.value,
        });
    };
    const handleChangeCapGiao = (event) => {
        setAdvanceFilter({
            ...advanceFilter,
            id_task_level: event.target.value,
        });
    };
    const handleChangeTag = (event) => {
        console.log("event", event.target.value);
        setAdvanceFilter({
            ...advanceFilter,
            tag:
                advanceFilter?.tag?.length > 0
                    ? advanceFilter?.tag?.some(
                        (item) => item === event.target.value
                    )
                        ? advanceFilter?.tag?.filter(
                            (item) => item !== event.target.value
                        )
                        : [...advanceFilter.tag, event.target.value]
                    : [event.target.value],
        });
    };
    const handleApply = () => {
        console.log("advanceFilter?.month", advanceFilter?.month);
        const date = advanceFilter?.month.$d
            ? new Date(advanceFilter.month.$d)
            : new Date(advanceFilter?.month);
        const from_date = new Date(date.getFullYear(), date.getMonth(), 1);
        const to_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        setFilter({
            ...filter,
            tag: advanceFilter?.tag?.join(","),
            from_date: moment(from_date).format("YYYY-MM-DD"),
            to_date: moment(to_date).format("YYYY-MM-DD"),
            date_by: advanceFilter.date_by,
            tien_do: advanceFilter.tien_do,
            id_task_level: advanceFilter.id_task_level,
        });
        onClose();
    };
    const handleReset = () => {
        setAdvanceFilter({
            ...advanceFilter,
            month: new Date(),
            tien_do: null,
            id_task_level: null,
            tag: [],
        });
    };
    console.log("advanceFilter", advanceFilter);
    const list = (
        <>
            <Box
                sx={{
                    width: "335px",
                    pt: "50px",
                    "& ul": {
                        position: "unset",
                        marginBottom: "70px",
                    },
                }}
                role="presentation"
            >
                <List>
                    <ListItem className="pb-0 small-text">
                        Hiển thị theo
                    </ListItem>
                    <ListItem>
                        <FormControl fullWidth>
                            <Select
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiSvgIcon-root": {
                                        color: "#0073C7",
                                    },
                                    border: "red",
                                }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={advanceFilter?.date_by}
                                onChange={handleChangeDateBy}
                            >
                                <MenuItem value="DISPLAY_DATE">
                                    Tháng hiển thị
                                </MenuItem>
                                <MenuItem value="CREATED_DATE">
                                    Ngày tạo
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem className="pb-0 small-text">Chọn tháng</ListItem>
                    <ListItem>
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="vi"
                        >
                            <DatePicker
                                openTo="month"
                                views={["month", "year"]}
                                value={advanceFilter.month}
                                onChange={handleChangeMonth}
                                inputFormat="MM/YYYY"
                                renderInput={(params) => (
                                    <TextField
                                        sx={{
                                            width: "100%",
                                            "& .MuiInputBase-input": {
                                                fontSize: "14px",
                                            },
                                        }}
                                        {...params}
                                        helperText={null}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </ListItem>
                    <ListItem className="pb-0 small-text">Tiến độ</ListItem>
                    <ListItem>
                        <FormControl fullWidth>
                            <Select
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiSvgIcon-root": {
                                        color: "#0073C7",
                                    },
                                    border: "red",
                                }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={advanceFilter?.tien_do}
                                onChange={handleChangeTienDo}
                                displayEmpty
                            >
                                <MenuItem value={null} disabled>
                                    <div className="opacity-60">Chọn</div>
                                </MenuItem>
                                <MenuItem value="001">Hoàn thành</MenuItem>
                                <MenuItem value="002">Chưa hoàn thành</MenuItem>
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem className="pb-0 small-text">Cấp giao</ListItem>
                    <ListItem>
                        <FormControl fullWidth>
                            <Select
                                sx={{
                                    fontSize: "14px",
                                    "& .MuiSvgIcon-root": {
                                        color: "#0073C7",
                                    },
                                    border: "red",
                                }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={advanceFilter?.id_task_level}
                                onChange={handleChangeCapGiao}
                                displayEmpty
                            >
                                <MenuItem value={null} disabled>
                                    <div className="opacity-60">Chọn</div>
                                </MenuItem>
                                {taskLevelList.map((item) => (
                                    <MenuItem value={item.id_level}>
                                        {item?.ten_cap}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem className="pb-0 small-text">
                        Loại nhiệm vụ
                    </ListItem>
                    <ListItem>
                        <FormGroup>
                            {tagList.map((item) => (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={advanceFilter?.tag?.some(
                                                (tag) => tag === item.code
                                            )}
                                            onChange={handleChangeTag}
                                            value={item.code}
                                        />
                                    }
                                    label={item.name}
                                />
                            ))}
                        </FormGroup>
                    </ListItem>
                    <ListItem className="pb-0 small-text flex items-center gap-[6px]">
                        <span>Lãnh đạo giao việc </span>
                        <MoreHorizCircle
                            className="text-primary"
                            onClick={() => {
                                setSelectUser({
                                    isOpen: true,
                                    type: ASSIGNEE_TYPE.LEADER,
                                });
                            }}
                        />
                    </ListItem>
                    <ListItem></ListItem>
                    <ListItem className="pb-0 small-text flex items-center gap-[6px]">
                        <span>Xử lý chính </span>
                        <MoreHorizCircle
                            className="text-primary"
                        // onClick={(e) => {
                        //     e.stopPropagation();
                        //     setOpenContent(true);
                        //     setTaskSelect(record);
                        // }}
                        />
                    </ListItem>
                    <ListItem></ListItem>
                    <ListItem className="pb-0 small-text flex items-center gap-[6px]">
                        <span>Phối hợp sử lý </span>
                        <MoreHorizCircle
                            className="text-primary"
                        // onClick={(e) => {
                        //     e.stopPropagation();
                        //     setOpenContent(true);
                        //     setTaskSelect(record);
                        // }}
                        />
                    </ListItem>

                    <ListItem></ListItem>
                </List>
            </Box>
            <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
                <button
                    onClick={handleReset}
                    className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]"
                >
                    <div className="font-semibold text-[14px] leading-[22px] px">
                        Nhập lại
                    </div>
                </button>
                <button
                    onClick={handleApply}
                    className="text-center w-1/2 block text-white rounded bg-primary py-[16px] ml-[5px]"
                >
                    <div className="font-semibold text-[14px] leading-[22px] px">
                        Áp dụng
                    </div>
                </button>
            </div>
        </>
    );

    return (
        <Fragment>
            <Drawer anchor={"right"} open={open} onClose={onClose} sx={{}}>
                {list}
                <SelecteUserDialog
                    open={selectUser.isOpen}
                    handleClose={() =>
                        setSelectUser({ isOpen: false, type: "" })
                    }
                />
            </Drawer>
        </Fragment>
    );
};

export default SearchAdvanceDrawer;
